<template>
  <div class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-3">

    <!-- MODAL -->
    <div class="w-full max-w-3xl bg-gradient-to-br from-white to-slate-100 rounded-2xl shadow-2xl p-6 relative
             max-h-[90vh] overflow-y-auto transform transition-all scale-100">

      <!-- BOTÓN CERRAR -->
      <button @click="$emit('cerrar')"
        class="absolute top-3 right-4 text-xl text-slate-500 hover:text-sky-500 transition">
        ✕
      </button>

      <h2 class="text-center text-3xl font-extrabold text-slate-800 mb-8">
        <span class="block text-sky-600 tracking-wide text-base font-semibold mb-2">
          — Nivel Actual de Estanque —
        </span>
      </h2>



      <!-- CONTENEDOR PRINCIPAL -->
      <!-- Fijo a la izquierda; los dos móviles, por separado, a la derecha. -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

        <!-- ====================== F I J O ====================== -->
        <div
          class="md:row-span-2 bg-slate-50 border border-slate-200 rounded-xl shadow-sm p-5 flex flex-col items-center justify-center gap-4 hover:shadow-lg transition">
          <h3 class="text-lg font-semibold text-sky-700">Estanque fijo</h3>

          <!-- GAUGE -->
          <div class="flex justify-center w-full h-[210px] md:h-[220px]">
            <FuelGaugeF :litros="nivelFijo" :max="maxFijo" />
          </div>

          <p class="text-sm text-slate-600">{{ nombreDispositivo(ID_FIJO, "Estanque Fijo") }}</p>
        </div>

        <!-- ====================== M Ó V I L ====================== -->
        <div
          class="bg-slate-50 border border-slate-200 rounded-xl shadow-sm p-5 flex flex-col items-center gap-4 hover:shadow-lg transition">
          <h3 class="text-lg font-semibold text-sky-700">Estanque móvil</h3>

          <!-- GAUGE -->
          <div class="flex justify-center w-full">
            <FuelGaugeM :litros="nivelMovil" :max="maxMovil" />
          </div>

          <p class="text-sm text-slate-600">{{ nombreDispositivo(ID_MOVIL, "Estanque Móvil") }}</p>
        </div>

        <!-- ==================== M Ó V I L  2 ==================== -->
        <div
          class="bg-slate-50 border border-slate-200 rounded-xl shadow-sm p-5 flex flex-col items-center gap-4 hover:shadow-lg transition">
          <h3 class="text-lg font-semibold text-sky-700">Estanque MOVIL 2</h3>

          <!-- GAUGE -->
          <div class="flex justify-center w-full">
            <FuelGaugeM :litros="nivelMovil2" :max="maxMovil2" />
          </div>

          <p class="text-sm text-slate-600">{{ nombreDispositivo(ID_MOVIL_2, "Estanque MOVIL 2") }}</p>
        </div>

      </div>

      <!-- ======================== HISTORIAL ======================== -->
      <div class="mt-7">
        <h3 class="text-sm font-semibold text-slate-600 mb-3">
          Historial de movimientos
        </h3>

        <HistorialEstanque :eventos="historial" />
      </div>

    </div>

  </div>
</template>



<script setup>
import FuelGaugeF from "@/components/DashboardUi/Nivel_Estanque/FuelGaugeFijo.vue";
import FuelGaugeM from "@/components/DashboardUi/Nivel_Estanque/FuelGaugeMovil.vue";
import HistorialEstanque from "@/components/DashboardUi/Nivel_Estanque/HistorialEstanque.vue";

const props = defineProps({
  nivelFijo: Number,
  nivelMovil: Number,
  nivelMovil2: Number,
  maxFijo: Number,
  maxMovil: Number,
  maxMovil2: Number,
  historial: { type: Array, default: () => [] },
  dispositivos: { type: Array, default: () => [] },
});

// Mismos dispositivo_id que el cálculo de niveles de SafcoDashboard.
const ID_FIJO = 1;
const ID_MOVIL = 2;
const ID_MOVIL_2 = 3;

// Nombre que entrega /dispositivos; si no llegó, el nombre fijo.
const nombreDispositivo = (id, porDefecto) =>
  props.dispositivos.find(d => Number(d.id) === id)?.nombre || porDefecto;
</script>
